var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.actions)?_c('div',{staticClass:"card-catalogue-page"},[_c('CardCatalogue',{attrs:{"catalogue":_vm.actions}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }